// extracted by mini-css-extract-plugin
export var dividerContainer = "_6i-0";
export var line = "_6i-1";